export enum AccessKeys {
    FeedFirstCard = "1",
    FeedStartup = "2",
    Search = "3",
    AutoComplete = "a",
    ReloadFeed = "r",
    Notification = "n",
    CreateContent = "c",
    UserMenu = "u"
}